<template>
  <div>
    <div class="NovaDivider" />
  </div>
</template>

<script setup lang="ts"></script>

<style scoped lang="scss">
@import "@/assets/scss/utilities";

.NovaDivider {
  border-bottom: 1px solid var(--color-neutral-60);
}
</style>
